// extracted by mini-css-extract-plugin
module.exports = {"ExternalLink":"index-module__ExternalLink___U6_5o","ExternalLinkInText":"index-module__ExternalLinkInText___3WmYS","ExternalLinkButton":"index-module__ExternalLinkButton___2qcz7"};